<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 v-if="role == 'employee' && !isManager()" class="page-title">My Monthly Overtime, Standby, and Shift Allowance Report</h3>
          <h3 v-else-if="role == 'employee' && isManager()" class="page-title">My Staff Monthly Overtime, Standby, and Shift Allowance Report</h3>
          <h3 v-else class="page-title">Monthly Overtime, Standby, and Shift Allowance Report</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Form -->
    <form @submit.prevent="search">
      <div v-if="role == 'admin' || isManager()" class="row align-items-center">
        <div class="col-md-2">Company</div>
        <div class="col-md-4 pl-md-0">
          <select class="custom-select" v-model="company" @change="changeCompany">
            <option
              v-for="(item, i) in companies"
              :key="i"
              :value="item.CompanyName"
            >
              {{ item.CompanyName }}
            </option>
          </select>
        </div>
        <div class="col-md-2 ml-md-4">Department</div>
        <div class="col-md-3 pl-md-0">
          <select class="custom-select" v-model="department">
            <option value="">All</option>
            <option v-for="item in departments" :key="item.Department" :value="item.Department">
                {{ item.Department }}
            </option>
          </select>
        </div>
      </div>

      <div class="row align-items-center mt-2">
        <div class="col-md-2">Approved Date From</div>
        <div class="col-md-4 pl-md-0">
          <input
            type="date"
            class="form-control"
            v-model="approvedDateFrom"
            required
          />
        </div>
        <div class="col-md-2 ml-md-4">Approved Date To</div>
        <div class="col-md-3 pl-md-0">
          <input
            type="date"
            class="form-control"
            v-model="approvedDateTo"
            required
          />
        </div>
      </div>

      <div class="row align-items-center mt-2">
        <div class="col-md-2">Timesheet Month / Year From</div>
        <div class="col-md-4 pl-md-0">
          <div class="row">
            <div class="col-md-6">
                <select class="custom-select" v-model="monthFrom" required>
                    <option value="Jan">Jan</option>
                    <option value="Feb">Feb</option>
                    <option value="Mar">Mar</option>
                    <option value="Apr">Apr</option>
                    <option value="May">May</option>
                    <option value="Jun">Jun</option>
                    <option value="Jul">Jul</option>
                    <option value="Aug">Aug</option>
                    <option value="Sep">Sep</option>
                    <option value="Oct">Oct</option>
                    <option value="Nov">Nov</option>
                    <option value="Dec">Dec</option>
                </select>
            </div>

            <div class="col-md-6">
                <select class="custom-select" v-model="yearFrom" required>
                    <option v-for="year in years" :key="year" :value="year">
                        {{ year }}
                    </option>
                </select>
            </div>
          </div>
        </div>

        <div class="col-md-2 ml-md-4">Timesheet Month / Year To</div>
        <div class="col-md-3 pl-md-0">
          <div class="row">
            <div class="col-md-6">
                <select class="custom-select" v-model="monthTo" required>
                    <option value="Jan">Jan</option>
                    <option value="Feb">Feb</option>
                    <option value="Mar">Mar</option>
                    <option value="Apr">Apr</option>
                    <option value="May">May</option>
                    <option value="Jun">Jun</option>
                    <option value="Jul">Jul</option>
                    <option value="Aug">Aug</option>
                    <option value="Sep">Sep</option>
                    <option value="Oct">Oct</option>
                    <option value="Nov">Nov</option>
                    <option value="Dec">Dec</option>
                </select>
            </div>

            <div class="col-md-6">
                <select class="custom-select" v-model="yearTo" required>
                    <option v-for="year in years" :key="year" :value="year">
                        {{ year }}
                    </option>
                </select>
            </div>
          </div>
        </div>
      </div>

      <div v-if="role == 'admin' || isManager()" class="row align-items-center mt-2">
        <div class="col-md-2">Job Grade</div>
        <div class="col-md-4 pl-md-0">
          <select class="custom-select" v-model="jobGrade">
            <option value="">All</option>
            <option v-for="item in jobGrades" :key="item.JobGrade" :value="item.JobGrade">
              {{ item.JobGrade }}
            </option>
          </select>
        </div>
        <div class="col-md-2 ml-md-4">Cost Centre</div>
        <div class="col-md-3 pl-md-0">
          <select class="custom-select" v-model="costCentre">
            <option value="">All</option>
            <option v-for="item in costCentres" :key="item.CostCentre" :value="item.CostCentre">
              {{ item.CostCentre }}
            </option>
          </select>
        </div>
      </div>

      <div v-if="role == 'admin' || isManager()" class="row align-items-center mt-2">
        <div class="col-md-2">Manager</div>
        <div class="col-md-4 pl-md-0">
          <select v-if="role == 'admin'" class="custom-select" v-model="manager">
            <option value="">All</option>
            <option v-for="item in managers" :key="item.id" :value="item.id">
              {{ item.text }}
            </option>
          </select>
          <span v-else>{{ managerName + " (" + managerEmployeeID + ")" }}</span>
        </div>
        <div class="col-md-2 ml-md-4">Designation</div>
        <div class="col-md-3 pl-md-0">
          <select class="custom-select" v-model="designation">
            <option value="">All</option>
            <option v-for="item in designations" :key="item.Designation" :value="item.Designation">
              {{ item.Designation }}
            </option>
          </select>
        </div>
      </div>
      
      <div class="row align-items-center mt-2">
        <div class="col-md-2">Employee Name/ID</div>
        <div class="col-md-4 pl-md-0">
          <Select2
            v-if="role == 'admin' || isManager()"
            v-model="userId"
            :options="employees"
          />
          <span v-else>{{ employeeName + " (" + employeeID + ")" }}</span>
        </div>
        <div class="col-md-2 ml-md-4">
          <button type="submit" class="btn btn-primary">Search</button>
        </div>
      </div>
    </form>
    <!-- /Form -->

    <!-- Pagination -->
    <div class="row mt-4 align-items-center" v-if="records && records.length">
      <div class="col-md-6">
        
      </div>
      <div class="col-md-6 text-right">
        <form
          ref="form"
          :action="backendUrl + '/AttendanceExcelReport/ExportMonthlyOvertimeStandbyShiftAllowance'"
          method="POST"
        >
          <input type="hidden" name="Company" :value="company" />
          <input type="hidden" name="Department" :value="department" />
          <input type="hidden" name="ApprovedDateFrom" :value="approvedDateFrom" />
          <input type="hidden" name="ApprovedDateTo" :value="approvedDateTo" />
          <input type="hidden" name="MonthFrom" :value="monthFrom" />
          <input type="hidden" name="MonthTo" :value="monthTo" />
          <input type="hidden" name="YearFrom" :value="yearFrom" />
          <input type="hidden" name="YearTo" :value="yearTo" />
          <input type="hidden" name="JobGrade" :value="jobGrade" />
          <input type="hidden" name="CostCentre" :value="costCentre" />
          <input type="hidden" name="ManagerID" :value="manager" />
          <input type="hidden" name="Designation" :value="designation" />
          <input type="hidden" name="EmployeeID" :value="userId" />
          <input type="hidden" name="Role" :value="role" />
          <button type="button" @click="exportExcel" class="btn btn-sm btn-primary">
            <img
              width="20px"
              height="20px"
              class="mr-1"
              src="../../assets/excel.png"
            />Export to Excel
          </button>
        </form>
      </div>
    </div>
    <!-- /Pagination -->

    <!-- Result Empty -->
    <div class="mt-4" v-if="records && records.length == 0">
      <div class="col-12 no-record">
        {{ noRecordText }}
      </div>
    </div>

    <!-- Result -->
    <div class="row mt-2" v-if="records && records.length">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th colspan="2">Employee</th>
                <th rowspan="2">Designation</th>
                <th rowspan="2">Department</th>
                <th rowspan="2">Job Grade</th>
                <th rowspan="2">Cost Centre</th>
                <th rowspan="2">Date<br>Approved</th>
                <th rowspan="2">Timesheet<br>Month/Year</th>
                <th colspan="2" v-if="!isNewLayout">No. of<br>OT hrs Clocked</th>
                <th :colspan="totalOtColSpan">Total OT</th>
                <th colspan="2">No. of<br>Standby<br>Session</th>
                <th rowspan="2">Total<br>Standby<br>Sesssion<br>Payment<br>Earned</th>
                <th colspan="2">No. of 8-hr<br>Shift<br>Session</th>
                <th colspan="2">No. of 12-hr<br>Shift<br>Session</th>
                <th rowspan="2">Total<br>Shift<br>Payment<br>Earned</th>
                <th rowspan="2">Swing<br>Shift<br>Day<br>Allowance</th>
                <th rowspan="2">Swing<br>Shift<br>Night<br>Allowance</th>
                <th rowspan="2">Swing<br>Shift<br>Saturday<br>Allowance</th>
                <th rowspan="2">Swing<br>Shift<br>Sunday<br>Allowance</th>
                <th rowspan="2">Total<br>Swing<br>Shift<br>Allowance</th>
              </tr>
              <tr>
                <th>Employee<br>ID</th>
                <th>Employee<br>Name</th>
                <th v-if="!isNewLayout">Mon<br>-<br>Fri</th>
                <th v-if="!isNewLayout">Sun<br>&<br>PH</th>
                <th v-if="role=='admin' && isNewLayout">OT 1.50<br>Hourly Rate</th>
                <th v-if="role=='admin' && isNewLayout">OT 2.00<br>Hourly Rate</th>
                <th>{{ isNewLayout ? 'OT Hours' : 'Hours' }}</th>
                <th>Payment<br>Earned</th>
                <th v-if="company==lrsCompany">Payment<br>Earned<br>(capped)</th>
                <th>12<br>Hrs</th>
                <th>24<br>Hrs</th>
                <th>Day</th>
                <th>Night</th>
                <th>Day</th>
                <th>Night</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in records" :key="i">
                <td>{{ item.EmployeeID }}</td>
                <td>{{ item.EmployeeName }}</td>
                <td>{{ item.Designation }}</td>
                <td>{{ item.Department }}</td>
                <td>{{ item.JobGrade }}</td>
                <td>{{ item.CostCentre }}</td>
                <td>{{ item.DateApprovedDisplay }}</td>
                <td>{{ item.MonthYear }}</td>
                <td v-if="!isNewLayout">{{ item.SumApprovedMonSat }}</td>
                <td v-if="!isNewLayout">{{ item.SumApprovedSunPH }}</td> 
                <td v-if="role=='admin' && isNewLayout">{{ item.SumOT150 }}</td>
                <td v-if="role=='admin' && isNewLayout">{{ item.SumOT200 }}</td>
                <td>{{ !isNewLayout ? (item.SumApprovedMonSat + item.SumApprovedSunPH) : item.SumApproved }}</td>
                <td>{{ commaSeparateNumber(item.OTPaymentEarned.toFixed(2)) }}</td>
                <td v-if="company==lrsCompany">{{ commaSeparateNumber(item.OTPaymentEarnedCapped.toFixed(2)) }}</td>
                <td>{{ item.Standby12Hr }}</td>
                <td>{{ item.Standby24Hr }}</td>
                <td>{{ commaSeparateNumber(item.TotalStandbyPaymentEarned.toFixed(2)) }}</td>
                <td>{{ item.SumShift8HrsDay }}</td>
                <td>{{ item.SumShift8HrsNight }}</td>
                <td>{{ item.SumShift12HrsDay }}</td>
                <td>{{ item.SumShift12HrsNight }}</td>
                <td>{{ commaSeparateNumber(item.TotalShiftPaymentEarned.toFixed(2)) }}</td>
                <td>{{ item.SumSwingShiftDayAllowance }}</td>
                <td>{{ item.SumSwingShiftNightAllowance }}</td>
                <td>{{ item.SumSwingShiftSaturdayAllowance }}</td>
                <td>{{ item.SumSwingShiftSundayAllowance }}</td>
                <td>{{ item.TotalSwingShiftAllowance }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Result -->   
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
import Select2 from "v-select2-component";

export default {
  components: { Select2 },
  data() {
    let data = JSON.parse(localStorage.getItem("lambitoken"));

    let userId = "", employeeName = "", employeeID = "", managerID = "", managerName = "", managerEmployeeID = "";
    if ( data.Role != "admin" && !data.IsManager ) {
      userId = data.Id;
      employeeName = data.Name;
      employeeID = data.EmployeeID;
    }
    else if ( data.Role != "admin" && data.IsManager ) {
      managerID = data.Id;
      managerName = data.Name;
      managerEmployeeID = data.EmployeeID;
    }

    return {
      isNewLayout: false,
      lrsCompany: config.DEFAULT_COMPANY,
      companies: [],
      departments: [],
      costCentres: [],
      designations: [],
      jobGrades: [],
      managers: [],
      employees: [],
      company: data.Role != 'admin' ? data.Company : '',
      department: "",
      costCentre: "",
      designation: "",
      jobGrade: "",
      manager: managerID,
      selectedEmployees: [],
      userId: userId,
      approvedDateFrom: "",
      approvedDateTo: "",
      monthFrom: "",
      monthTo: "",
      yearFrom: "",
      yearTo: "",
      records: [],
      role: data.Role,
      employeeName: employeeName,
      employeeID: employeeID,
      managerName: managerName,
      managerEmployeeID: managerEmployeeID,




      years: [],
      types: [],
      categories: [],
      
      //search form
      
      year: "",
      typeId: "",
      categoryId: "",
      groupDental: "",
      groupHsmm: "",
      //for excel
      companyForExcel: "",
      yearForExcel: "",
      typeIdForExcel: "",
      categoryIdForExcel: "",
      groupDentalForExcel: "",
      groupHsmmForExcel: "",
      noRecordText: config.NO_RECORD_TEXT,
      //pagination
      paging: {
        Search: "",
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 5,
        Sizes: [5, 10, 20, 100],
        SortBy: "",
      },
      totalRecords: "",
    };
  },

  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    /*role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },*/
    backendUrl() {
      return this.$backendUrl;
    },
    totalOtColSpan(){
      let colspan = 0;
      if (this.isNewLayout && this.role == "admin") {
        colspan = this.company == this.lrsCompany ? 5 : 4;
      } else {
        colspan = this.company == this.lrsCompany ? 3 : 2;
      }
      return colspan;
    }
  },

  watch: {
    typeId(val) {
      this.categoryId = "";
      if (!val) {
        this.categories = [];
        return;
      }
      let param = {
        Token: this.token,
        Id: val,
      };
      this.$store.state.isLoading = true;
      API.getInsuranceCategoryMappingEnrolmentCategories(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.categories = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    "paging.SizePerPage": function (val, oldVal) {
      this.paging.CurrentPage = 1;
      this.search();
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
  },

  methods: {
    isManager() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.IsManager ? data.IsManager : false;
    },
    commaSeparateNumber(val) {
      // remove sign if negative
      var sign = 1;
      if (val < 0) {
        sign = -1;
        val = -val;
      }

      // trim the number decimal point if it exists
      let num = val.toString().includes('.') ? val.toString().split('.')[0] : val.toString();

      while (/(\d+)(\d{3})/.test(num.toString())) {
        // insert comma to 4th last position to the match number
        num = num.toString().replace(/(\d+)(\d{3})/, '$1' + ',' + '$2');
      }

      // add number after decimal point
      if (val.toString().includes('.')) {
        num = num + '.' + val.toString().split('.')[1];
      }

      // return result with - sign if negative
      return sign < 0 ? '-' + num : num;
    },
    getAttendanceReportSelection() {
        let param = {
        Token: this.token,
      };
      this.$store.state.isLoading = true;
      API.getAttendanceReportSelection(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.companies = response.data.companies;
            this.costCentres = response.data.costCentres;
            this.departments = response.data.departments;
            this.designations = response.data.designations;
            this.jobGrades = response.data.jobGrades;
            this.managers = response.data.managers;
            this.employees = response.data.employees;
            this.employees.unshift({ id: "All", text: "All" });

            this.company = this.companies[0].CompanyName;
            this.userId = "All";
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getEmployees() {
      let param = { Token: this.token, Company: this.company };
      this.$store.state.isLoading = true;
      API.getEmployees(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.employees = response.data.record;
            this.employees.unshift({ id: "All", text: "All" });

            this.userId = "All";
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
            console.log(error);
            this.$store.state.isLoading = false;
            this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getManagerEmployees() {
      let param = { Token: this.token, IsActive: true, ManagerID: this.managerEmployeeID, Company: this.company };
      this.$store.state.isLoading = true;
      API.getManagerEmployees(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.employees = response.data.record;
            this.employees.unshift({ id: "All", text: "All" });
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getManagers() {
      let param = { Token: this.token, Company: this.company };
      this.$store.state.isLoading = true;
      API.getManagers(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.managers = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
            console.log(error);
            this.$store.state.isLoading = false;
            this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    changeCompany() {
      if ( this.isManager() ) {
        this.getManagerEmployees();
      }
      else {
        this.getEmployees();
      }
      this.getManagers();
    },
    

    getYears() {
      let param = { Token: this.token, IsActive: true };
      this.$store.state.isLoading = true;
      API.getYears(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.years = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    search() {
      //actual search
      let param = {
        Token: this.token,
        /*Search: this.paging.Search,
        CurrentPage: this.paging.CurrentPage,
        TotalPage: this.paging.TotalPage,
        SizePerPage: this.paging.SizePerPage,
        SortBy: this.paging.SortBy,
        searchFilter: this.searchFilter,*/
        Company: this.company,
        Department: this.department,
        ApprovedDateFrom: this.approvedDateFrom,
        ApprovedDateTo: this.approvedDateTo,
        MonthFrom: this.monthFrom,
        MonthTo: this.monthTo,
        YearFrom: this.yearFrom,
        YearTo: this.yearTo,
        JobGrade: this.jobGrade,
        CostCentre: this.costCentre,
        ManagerID: this.manager,
        Designation: this.designation,
        SelectedEmployeeID: []
      };

      if ( this.userId != "" && this.userId != "All" ) {
        param.SelectedEmployeeID.push(this.userId);
      }

      this.$store.state.isLoading = true;
      API.searchMonthlyOvertimeStandbyShiftAllowanceTimesheet(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            /*
            this.totalRecords = response.data.total;
            this.paging.TotalPage = response.data.pageCount;
            if (this.paging.CurrentPage > this.paging.TotalPage) {
              this.paging.CurrentPage = 1;
            }*/
            let mixedLayoutMessage = response.data.mixedLayoutMessage;
            if (mixedLayoutMessage) {
              alert(mixedLayoutMessage);
              return;
            }

            if ( response.data.isEmpty ) {
              this.records = [];
            }
            else {
              this.isNewLayout = response.data.isNewLayout;
              this.records = response.data.record;
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          // this.$swal(error.response.data.Message, { icon: "error" });
          this.records = [];
          console.log("error", error.response.data.Message);
        });
    },
    exportExcel(){
      let param = {
        Token: this.token,
        Company: this.company,
        MonthFrom: this.monthFrom,
        MonthTo: this.monthTo,
        YearFrom: this.yearFrom,
        YearTo: this.yearTo
      };
      API.checkMixedLayout(param)
        .then((response) => {
          if (response.data.success) {
            let mixedLayoutMessage = response.data.mixedLayoutMessage;
            if (mixedLayoutMessage) {
              alert(mixedLayoutMessage);
              return;
            } else {
              this.$refs.form.submit();
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //pagination method
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.search();
    },
    first() {
      this.paging.CurrentPage = 1;
      this.search();
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.search();
    },
    next() {
      this.paging.CurrentPage += 1;
      this.search();
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.search();
    },
  },

  created() {
    if ( this.role == 'admin' || this.isManager() ) this.getAttendanceReportSelection();

    this.getYears();
  },
};
</script>

<style scoped>
.col-md-2 {
  max-width: 185px;
}
th, td {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Attendance/MonthlyOvertimeStandbyShiftAllowanceReport.vue